import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { ContactDialogModule } from '../contact-dialog/contact-dialog.module';

import { PartnershipComponent } from './partnership.component';

@NgModule({
	declarations: [PartnershipComponent],
	imports: [BrowserModule, RouterModule, ContactDialogModule],
	exports: [PartnershipComponent],
})
export class PartnershipModule {}
